let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c2wP7")).then(() => parcelRequire('gD4xH'));